import React from 'react';
import ReactDOM from 'react-dom/client';
// import Swal from 'sweetalert2';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

// Service worker: precache asset statis, network-only untuk navigasi
// (aman untuk domain yang juga melayani /tte, /lapor-mbg, dll lewat proxy).
// Update TIDAK dipaksa otomatis -- user dikasih pilihan kapan mau reload,
// biar gak kehilangan input form/state yang lagi dikerjakan pas update kedetect.
serviceWorkerRegistration.register(
    // {
    //     onUpdate: (registration) => {
    //         if (!registration.waiting) return;

    //         Swal.fire({
    //             title: 'Update Tersedia',
    //             text: 'Versi terbaru halaman ini sudah siap. Muat ulang sekarang?',
    //             icon: 'info',
    //             showCancelButton: true,
    //             confirmButtonText: 'Muat Ulang',
    //             cancelButtonText: 'Nanti',
    //             allowOutsideClick: false,
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    //             }
    //         });
    //     },
    // }
);

// if ('serviceWorker' in navigator) {
//     let refreshing = false;
//     navigator.serviceWorker.addEventListener('controllerchange', () => {
//         // Listener ini baru trigger reload SETELAH user klik "Muat Ulang"
//         // di atas (yang kirim SKIP_WAITING). Bukan otomatis di background.
//         if (refreshing) return;
//         refreshing = true;
//         window.location.reload();
//     });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();